import { Injectable } from '@angular/core';
import { SidenavType } from '@app/core/sidenav-type';
import { FooterVersion } from '@app/shared/footer-version-select/footer-version-select.component';
import { PersonResult } from '@pezi/entities';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class FooterVersionSelectService {
  public currentVersions = new BehaviorSubject<FooterVersion>(null);

  public initNewVersions(currentVersion: number, type: SidenavType, versionen: PersonResult[], currentSubPage: string): void {
    this.currentVersions.next({
      currentVersion: currentVersion,
      type: type,
      currentSubPage: currentSubPage,
      versionen: versionen
    });
  }
}
